import { createSlice } from '@reduxjs/toolkit';
import {
    createCheckoutSession,
    getSubscriptionPlans,
    getSubscriptionStatus,
    verifyPaymentSession,
} from '../thunks/paymentsThunk';

const initialState = {
    subscriptionPlans: [],
    loading: false,
    error: null,
    checkoutSession: null,
    checkoutLoading: false,
    checkoutError: null,
    paymentVerification: null,
    verifyLoading: false,
    verifyError: null,
    subscriptionStatus: null,
    statusLoading: false,
    statusError: null,
};

const paymentSlice = createSlice({
    name: 'payments',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSubscriptionPlans.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getSubscriptionPlans.fulfilled, (state, action) => {
                state.loading = false;
                state.subscriptionPlans = action.payload;
            })
            .addCase(getSubscriptionPlans.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(createCheckoutSession.pending, (state) => {
                state.checkoutLoading = true;
                state.checkoutError = null;
                state.checkoutSession = null;
            })
            .addCase(createCheckoutSession.fulfilled, (state, action) => {
                state.checkoutLoading = false;
                state.checkoutSession = action.payload;
            })
            .addCase(createCheckoutSession.rejected, (state, action) => {
                state.checkoutLoading = false;
                state.checkoutError = action.payload;
            })
            .addCase(verifyPaymentSession.pending, (state) => {
                state.verifyLoading = true;
                state.verifyError = null;
                state.paymentVerification = null;
            })
            .addCase(verifyPaymentSession.fulfilled, (state, action) => {
                state.verifyLoading = false;
                state.paymentVerification = action.payload;
                // subscriptionStatus is only ever set from getSubscriptionStatus -
                // verifyPaymentSession's response ({success, message}) has a
                // different shape and would wipe out is_active/status here.
            })
            .addCase(verifyPaymentSession.rejected, (state, action) => {
                state.verifyLoading = false;
                state.verifyError = action.payload;
            })
            .addCase(getSubscriptionStatus.pending, (state) => {
                state.statusLoading = true;
                state.statusError = null;
            })
            .addCase(getSubscriptionStatus.fulfilled, (state, action) => {
                state.statusLoading = false;
                state.subscriptionStatus = action.payload;
            })
            .addCase(getSubscriptionStatus.rejected, (state, action) => {
                state.statusLoading = false;
                state.statusError = action.payload;
            });
    },
});

export default paymentSlice.reducer;
